import $ from 'jquery'
import { fetchCrossSiteToken, getFromLocalStorage, storeCrossSiteToken } from '../utils/utility'
import uuid from 'uuid-random';
import { APP_SOURCE, HTTPS_METHOD } from '../utils/constant';

const HTTP_REQUEST = (function () {

  /******************************************/
  /*  PRIVATE METHODS                       */
  /******************************************/
  const source = getFromLocalStorage('hcsource')
  function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply)
  }

  function makeCall(obj, success, error) {

    const errorCb = (response, url) => {
      error(response)
    }

    obj.headers = fetchCrossSiteToken(obj.method, obj.url, obj.headers)
    obj.headers = {
      ...obj.headers,
      requestId: uuid(),
      username: getFromLocalStorage('userId')
    }
    
    let options = {
      url: obj.url,
      method: obj.method,
      data: obj.data || {},
      headers: obj.headers,
      dataType: obj.dataType,
      global: false,
      success: (response, textStatus, jqXHR) => {
        storeCrossSiteToken(jqXHR, obj.url)
        success?.(response, textStatus, jqXHR); 
      },
      error: (response) => {
        errorCb(response, obj.url);
      }
    }

    $.ajax(options)
  }

  /******************************************/
  /*  PUBLIC METHODS                        */
  /******************************************/

  function START_WS(url, success, error) {
    const method = HTTPS_METHOD.GET
    const dataType = 'JSON'
    const headers = {
      'Content-Type': '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }

    if (!url) {
      return
    }

    makeCall({
      method,
      url,
      data: null,
      headers,
      dataType,
    }, success, error)
  }
  function STOP_WS(url, success, error) {
    const method = HTTPS_METHOD.GET
    const dataType = 'JSON'
    const headers = {
      'Content-Type': '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }

    if (!url) {
      return
    }

    makeCall({
      method,
      url,
      data: null,
      headers,
      dataType,
    }, success, error)
  }

  function GET(url, details = null, success, error) {
    const method = HTTPS_METHOD.GET
    const dataType = 'JSON'
    let headers = {
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }
    if (details) {
      headers['Content-type'] = 'application/json';
    }
    
    if (details?.userId) {
      headers.userId = details.userId;
    }
    if(details?.headers){
      headers = {...headers, ...details.headers}
      delete details.headers;
    }

    if (!url) {
      return
    }

    makeCall({
      method,
      url,
      data: details,
      headers,
      dataType,
    }, success, error)
  }

  function PUT(url, details = {}, success, error) {
    const method = HTTPS_METHOD.PUT
    const dataType = 'JSON'
    const body = (details?.body) ? details.body : details
    const headers = {
      'Content-Type': body ? 'application/json' : '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }

    if (!url) {
      return
    }

    if (!isFunction(success)) {
      return
    }

    if (!isFunction(error)) {
      return
    }

    makeCall({
      method,
      url,
      data: JSON.stringify(body),
      headers,
      dataType,
    }, success, error)
  }
  function PATCH(url, details = {}, success, error) {
    const method = HTTPS_METHOD.PATCH
    const dataType = 'JSON'
    const body = (details?.body) ? details.body : details
    const headers = {
      'Content-Type': body ? 'application/json' : '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }

    if (!url) {
      return
    }

    if (!isFunction(success)) {
      return
    }

    if (!isFunction(error)) {
      return
    }

    makeCall({
      method,
      url,
      data: JSON.stringify(body),
      headers,
      dataType,
    }, success, error)
  }

  function POST(url, details = {}, success, error) {
    const method = HTTPS_METHOD.POST
    const dataType = 'JSON'
    const isUrlEncoded = details.headers && details.headers['Content-Type'] === 'application/x-www-form-urlencoded';
    const body = (details.body) ? details.body : details
    let headers = {
      'Content-Type': body ? 'application/json' : '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }
    if(details?.useCustomHeaderOnly) {
      headers = details.headers || {}
    } else if(details?.headers){
      headers = {...headers, ...details.headers}
    }
    
    if (!url) {
      return
    }

    if (!isFunction(success)) {
      return
    }

    if (!isFunction(error)) {
      return
    }
    makeCall({
      method,
      url,
      data: isUrlEncoded ? body : JSON.stringify(body),
      headers,
      dataType,
    }, success, error)
  }

  function DELETE(url, details = null, success, error) {
    const method = HTTPS_METHOD.DELETE
    const dataType = 'JSON'
    const headers = {
      'Content-Type': details ? 'application/json' : '',
      'e-auth-token': getFromLocalStorage('session'),
      ...(source === APP_SOURCE.ENHO ? {'Authorization': 'Bearer ' +  getFromLocalStorage('token')} : {})
    }
    const body = details?.body ?? details ?? {}

    if (!url) {
      return
    }

    makeCall({
      method,
      url,
      data: JSON.stringify(body),
      headers,
      dataType,
    }, success, error)
  }

  return {
    GET,
    PUT,
    POST,
    PATCH,
    DELETE,
    START_WS,
    STOP_WS,
    makeCall
  }
}())

export default HTTP_REQUEST
